<template>
    <div>
        <div class="container">
            <b-breadcrumb :items="breadcrumb"></b-breadcrumb>

            <div class="row">
                <div class="col-lg-3">

                    <div class="d-none d-xl-block">
                        <catalog-categories></catalog-categories>
                    </div>

                </div>
                <div class="col-lg-9">
                    <div class="box-shadow">
                        <h1 class="as-h2 mb-28">{{ h1 }}</h1>
                        <div>
                            <ul>
                                <base-link v-for="(item, i) in sitemap" :key="i" :item="item" :url="''"/>
                            </ul>
                        </div>
                    </div>

                    <div class="mt-5" v-if="seo_text">
                        <p v-html="seo_text"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import BaseLink from "./BaseLink.vue";

export default {
    components: {BaseLink},
    data() {
        return {
            sitemap: [],
            h1: '',

            breadcrumb: [
                {
                    text: 'Главная',
                    to: {name: 'pages-index'}
                },
                {
                    text: 'Карта сайта',
                    active: true
                }
            ],
            seo_text: null
        }
    },
    created() {
        this.init();
    },
    methods: {
        init() {
            let url = '/api/sitemap';
            axios.get(url)
                .then(response => {
                    console.log(response.data)
                    this.sitemap = response.data.sitemap;

                    let seoInfo = response.data.seoInfo
                    this.seo_text = response.data.seoInfo.seo_text
                    this.h1 = response.data.seoInfo.seo_h1

                    document.title = seoInfo?.seo_title ? seoInfo?.seo_title : 'Карта сайта';
                    let desc = seoInfo?.seo_desc ? seoInfo?.seo_desc : 'Карта сайта.';
                    document.querySelector('meta[name="description"]').setAttribute("content", desc);
                    document.querySelector('meta[name="twitter:description"]').setAttribute("content", desc);
                    document.querySelector('meta[property="og:description"]').setAttribute("content", desc);
                    document.querySelector('meta[name="twitter:text:description"]').setAttribute("content", desc);

                })
        },
    }
}
</script>
